/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Notes_Notes_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter notes..." |
*
* @param {Event_Notes_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_notes_notes_placeholder = /** @type {((inputs?: Event_Notes_Notes_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Notes_Notes_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Entrez des notes...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Notizen eingeben...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci le note...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите примечания...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introducir notas...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入备注……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メモを入力してください...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नोट्स लिखें...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira notas...")
	return /** @type {LocalizedString} */ ("Enter notes...")
});